import Script from 'next/script';

const AffiliateFutureTag = () => (
  <Script
    id='affiliateFuture'
    src="//tags.affiliatefuture.com/7337.js" // where 7337 is our Affiliate Future MERCHANT_ID
  />
);

export default AffiliateFutureTag;